import React from 'react';
import { cn } from '@/lib/utils';

interface VisuallyHiddenProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
  asChild?: boolean;
}

/**
 * VisuallyHidden Component for Screen Reader Content
 * WCAG 2.1 AA compliant way to hide content visually while keeping it accessible
 */
export const VisuallyHidden: React.FC<VisuallyHiddenProps> = ({
  children,
  className,
  asChild = false,
  ...props
}) => {
  const hiddenClasses = cn(
    // Visually hide the element but keep it accessible to screen readers
    "absolute w-px h-px p-0 -m-px overflow-hidden",
    "whitespace-nowrap border-0",
    // Ensure it's positioned outside the viewport
    "clip-[rect(0,0,0,0)]",
    className
  );

  if (asChild && React.isValidElement<{ className?: string }>(children)) {
    return React.cloneElement(children, {
      ...props,
      className: cn(hiddenClasses, children.props.className),
    });
  }

  return (
    <span className={hiddenClasses} {...props}>
      {children}
    </span>
  );
};
